import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { Benefit } from '../../types/content';
interface BenefitListProps {
  items: Benefit[];
  columns?: 1 | 2 | 3;
}
export function BenefitList({
  items,
  columns = 2
}: BenefitListProps) {
  const grid = columns === 1 ? '' : columns === 2 ? 'md:grid-cols-2' : 'md:grid-cols-2 lg:grid-cols-3';
  return <ul className={`grid gap-x-10 ${grid}`} data-id="element-754" data-mp="2lwxdyk5kbxpy">
      {items.map(item => <li key={item.title} className="flex gap-4 border-b border-line py-5" data-id="element-755" data-mp="30qiu3utah1rr">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[11px] bg-brand text-white" aria-hidden="true" data-id="element-756" data-mp="2vrxunxlv2m4d">
            <CheckIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-757" data-mp="39mi0fd0xdd3z" />
          </span>
          <div data-id="element-758" data-mp="35jbyuiorca3u">
            <h3 className="type-icon-title text-ink" data-id="element-759" data-mp="35kwt0775tr16">{item.title}</h3>
            <p className="mt-1 type-card-desc" data-id="element-760" data-mp="3jjcyxvx77di9">{item.text}</p>
          </div>
        </li>)}
    </ul>;
}